export function isInTelegram(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }
    return !(window as any).__TELEGRAM_MOCKED__;
}

export function isMockedEnvironment(): boolean {
    return process.env.REACT_APP_DEV === 'true' && !isInTelegram();
}

export function mockSafeAreaCssVars(): void {
    if (typeof document === 'undefined') {
        return;
    }

    const root = document.documentElement;
    const topInset = getComputedStyle(root).getPropertyValue('--tg-viewport-content-safe-area-inset-top').trim();
    if (!topInset || topInset === '') {
        root.style.setProperty('--tg-viewport-content-safe-area-inset-top', '56px');
    }
    const safeAreaTop = getComputedStyle(root).getPropertyValue('--tg-viewport-safe-area-inset-top').trim();
    if (!safeAreaTop || safeAreaTop === '') {
        root.style.setProperty('--tg-viewport-safe-area-inset-top', '0px');
    }

    root.style.setProperty('--tg-viewport-safe-area-inset-bottom', '0px');
    root.style.setProperty('--tg-viewport-content-safe-area-inset-bottom', '0px');
}
